import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import { connect } from 'react-redux';
import { fetchUsersLocations } from './reducer';

import Marker from './marker';
import createMapOptions from './createMapOptions';
import worker from './map.worker.js';
import { styled } from 'themes';
import { IoMdLocate } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

interface UserLocations {
  customerCount: number;
  customers: {}[];
  yepCount: number;
  yeps: {}[];
}

interface Props {
  userLocations: UserLocations;
  fetchUsersLocations: () => any;
  moveToUserLocation: () => any;
}

const DEFAULT_LOCATION = {
  lat: 59.3293,
  lng: 18.0686,
};

const Map = (props: Props) => {
  const [clusters, setClusters] = useState([]);
  const [mapProps, setMapProps] = useState({});
  const [clusterWorker, setClusterWorker] = useState({});
  const [currentLocation, setCurrentLocation] = useState(DEFAULT_LOCATION);
  const [t] = useTranslation();

  useEffect(() => {
    props.fetchUsersLocations();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const newWorker = new worker();

      newWorker.addEventListener('message', event => {
        const newClusters = event.data;
        setClusters(newClusters);
      });

      setClusterWorker(newWorker);
      return () => {
        // clusterWorker.removeEventListener('message');
        setClusterWorker({});
      };
    }
  }, []);

  useEffect(() => {
    // const clusters = foo(props.userLocations, mapProps);
    // setClusters(clusters);
    if (clusterWorker.postMessage) {
      clusterWorker.postMessage({
        userLocations: props.userLocations,
        mapProps,
      });
    }
  }, [props.userLocations.customers, mapProps, clusterWorker]);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        setCurrentLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    } else {
      alert('Your browser does not support geolocation');
    }
  };

  return (
    <Container>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyALcbU2UZf7dnpNQzJvjQrTTKAM2GDneWo' }}
        defaultCenter={DEFAULT_LOCATION}
        center={currentLocation}
        defaultZoom={14}
        options={createMapOptions}
        onChange={setMapProps}
      >
        {clusters.map((cluster, i) => (
          <Marker {...cluster} key={i} />
        ))}
      </GoogleMapReact>
      <MyPositionButton onClick={getLocation}>
        <IoMdLocate />
        <span>{t('map.location-button')}</span>
      </MyPositionButton>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const MyPositionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;

  margin: 1.5rem;
  padding: 1.5rem;
  background-color: white;
  border: none;
  border-radius: 3px;

  color: ${({ theme }) => theme.colors.darkOrange};
  font-size: 1.7rem;
  font-weight: 700;
  box-shadow: 0 2rem 5rem rgba(0, 0, 0, 0.2);
  outline: none;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  & > span {
    margin-top: 1px;
    margin-left: 5px;
    line-height: 1;
  }
`;

export default connect(
  state => ({
    userLocations: state.mapReducer.userLocations,
  }),
  {
    fetchUsersLocations,
  }
)(Map);
